import { CurrencyTypeEnum } from '@app/interfaces/interfaces';

export const currencies = {
  [CurrencyTypeEnum.USD]: {
    text: 'USD',
    icon: '$',
  },
  [CurrencyTypeEnum.BTC]: {
    text: 'BTC',
    icon: '₿',
  },
  [CurrencyTypeEnum.ETH]: {
    text: 'ETH',
    icon: 'Ξ',
  },
  [CurrencyTypeEnum.LK]: {
    text: 'LKR',
    icon: 'Rs',
  },
};
